export default function Noise() {
  return <div className="noise-overlay" aria-hidden="true" data-testid="noise-overlay" />;
}
